import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { onOpenBoardEditor, onCloseBoardEditor } from 'owa-calendar-board-editor';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarModuleStitches" */ './lazyIndex')
);

registerLazyOrchestrator(onOpenBoardEditor, lazyModule, m => m.onOpenBoardEditorOrchestrator);
registerLazyOrchestrator(onCloseBoardEditor, lazyModule, m => m.onCloseBoardEditorOrchestrator);
